export default __webpack_public_path__ + "static/TSD_Tagger_Graphs-1-75e6aa3312724a7d4f9b9c5495155a7f.png";